// Supported ISO 639.1 Languages
export const ISO_639_1_ENGLISH = 'en';
export const ISO_639_1_BULGARIAN = 'bg';
export const ISO_639_1_CZECH = 'cs';
export const ISO_639_1_DANISH = 'da';
export const ISO_639_1_GERMAN = 'de';
export const ISO_639_1_ESTONIAN = 'et';
export const ISO_639_1_SPANISH = 'es';
export const ISO_639_1_FINNISH = 'fi';
export const ISO_639_1_FRENCH = 'fr';
export const ISO_639_1_GREEK = 'el';
export const ISO_639_1_CROATIAN = 'hr';
export const ISO_639_1_ITALIAN = 'it';
export const ISO_639_1_LATVIAN = 'lv';
export const ISO_639_1_LITHUANIAN = 'lt';
export const ISO_639_1_HUNGARIAN = 'hu';
export const ISO_639_1_DUTCH = 'nl';
export const ISO_639_1_NORSE = 'no';
export const ISO_639_1_POLISH = 'pl';
export const ISO_639_1_PORTUGUESE = 'pt';
export const ISO_639_1_ROMANIAN = 'ro';
export const ISO_639_1_RUSSIAN = 'ru';
export const ISO_639_1_SLOVAK = 'sk';
export const ISO_639_1_SLOVENIAN = 'sl';
export const ISO_639_1_SERBIAN = 'sr';
export const ISO_639_1_SWEDISH = 'sv';
export const ISO_639_1_THAI = 'th';
export const ISO_639_1_VIETNAMESE = 'vi';
export const ISO_639_1_TURKISH = 'tr';
export const ISO_639_1_UKRAINIAN = 'uk';
export const ISO_639_1_CHINESE = 'zh';
export const ISO_639_1_JAPANESE = 'ja';
export const ISO_639_1_KOREAN = 'ko';
// Supported ISO-3166 Country Codes
export const ISO_3166_USA = 'US';
export const ISO_3166_BULGARIA = 'BG';
export const ISO_3166_CZECH_REPUBLIC = 'CZ';
export const ISO_3166_DENMARK = 'DK';
export const ISO_3166_GERMANY = 'DE';
export const ISO_3166_ESTONIA = 'EE';
export const ISO_3166_UK = 'GB';
export const ISO_3166_SPAIN = 'ES';
export const ISO_3166_MEXICO = 'MX';
export const ISO_3166_FINLAND = 'FI';
export const ISO_3166_CANADA = 'CA';
export const ISO_3166_FRANCE = 'FR';
export const ISO_3166_GREECE = 'GR';
export const ISO_3166_CROATIA = 'HR';
export const ISO_3166_ITALY = 'IT';
export const ISO_3166_LATVIA = 'LV';
export const ISO_3166_LITHUANIA = 'LT';
export const ISO_3166_HUNGARY = 'HU';
export const ISO_3166_NETHERLAND = 'NL';
export const ISO_3166_NORWAY = 'NO';
export const ISO_3166_POLAND = 'PL';
export const ISO_3166_BRAZIL = 'BR';
export const ISO_3166_PORTUGAL = 'PT';
export const ISO_3166_ROMANIA = 'RO';
export const ISO_3166_RUSSIA = 'RU';
export const ISO_3166_SLOVAKIA = 'SK';
export const ISO_3166_SLOVENIA = 'SI';
export const ISO_3166_SERBIA = 'RS';
export const ISO_3166_SWEDEN = 'SE';
export const ISO_3166_SWITZERLAND = 'CH';
export const ISO_3166_THAILAND = 'TH';
export const ISO_3166_VIETNAM = 'VN';
export const ISO_3166_TURKEY = 'TR';
export const ISO_3166_UKRAINE = 'UA';
export const ISO_3166_CHINA = 'CN';
export const ISO_3166_TAIWAN = 'TW';
export const ISO_3166_JAPAN = 'JP';
export const ISO_3166_KOREA = 'KR';
// Supported Locales
export const LOCALE_ENGLISH_USA = `${ISO_639_1_ENGLISH}-${ISO_3166_USA}`;
export const LOCALE_BULGARIAN_BULGARIA = `${ISO_639_1_BULGARIAN}-${ISO_3166_BULGARIA}`;
export const LOCALE_CZECH_CZECH_REPUBLIC = `${ISO_639_1_CZECH}-${ISO_3166_CZECH_REPUBLIC}`;
export const LOCALE_DANISH_DENMARK = `${ISO_639_1_DANISH}-${ISO_3166_DENMARK}`;
export const LOCALE_GERMAN_GERMANY = `${ISO_639_1_GERMAN}-${ISO_3166_GERMANY}`;
export const LOCALE_GERMAN_SWITZERLAND = `${ISO_639_1_GERMAN}-${ISO_3166_SWITZERLAND}`;
export const LOCALE_ESTONIAN_ESTONIA = `${ISO_639_1_ESTONIAN}-${ISO_3166_ESTONIA}`;
export const LOCALE_ENGLISH_UK = `${ISO_639_1_ENGLISH}-${ISO_3166_UK}`;
export const LOCALE_SPANISH_SPAIN = `${ISO_639_1_SPANISH}-${ISO_3166_SPAIN}`;
export const LOCALE_SPANISH_MEXICO = `${ISO_639_1_SPANISH}-${ISO_3166_MEXICO}`;
export const LOCALE_FINISH_FINLAND = `${ISO_639_1_FINNISH}-${ISO_3166_FINLAND}`;
export const LOCALE_FRENCH_CANADA = `${ISO_639_1_FRENCH}-${ISO_3166_CANADA}`;
export const LOCALE_FRENCH_FRANCE = `${ISO_639_1_FRENCH}-${ISO_3166_FRANCE}`;
export const LOCALE_GREEK_GREECE = `${ISO_639_1_GREEK}-${ISO_3166_GREECE}`;
export const LOCALE_CROATIAN_CROATIA = `${ISO_639_1_CROATIAN}-${ISO_3166_CROATIA}`;
export const LOCALE_ITALIAN_ITALY = `${ISO_639_1_ITALIAN}-${ISO_3166_ITALY}`;
export const LOCALE_LATVIAN_LATVIA = `${ISO_639_1_LATVIAN}-${ISO_3166_LATVIA}`;
export const LOCALE_LITHUANIAN_LITHUANIA = `${ISO_639_1_LITHUANIAN}-${ISO_3166_LITHUANIA}`;
export const LOCALE_HUNGARIAN_HUNGARY = `${ISO_639_1_HUNGARIAN}-${ISO_3166_HUNGARY}`;
export const LOCALE_DUTCH_NETHERLAND = `${ISO_639_1_DUTCH}-${ISO_3166_NETHERLAND}`;
export const LOCALE_NORSE_NORWAY = `${ISO_639_1_NORSE}-${ISO_3166_NORWAY}`;
export const LOCALE_POLISH_POLAND = `${ISO_639_1_POLISH}-${ISO_3166_POLAND}`;
export const LOCALE_PORTUGUESE_BRAZIL = `${ISO_639_1_PORTUGUESE}-${ISO_3166_BRAZIL}`;
export const LOCALE_PORTUGUESE_PORTUGAL = `${ISO_639_1_PORTUGUESE}-${ISO_3166_PORTUGAL}`;
export const LOCALE_ROMANIAN_ROMANIA = `${ISO_639_1_ROMANIAN}-${ISO_3166_ROMANIA}`;
export const LOCALE_RUSSIAN_RUSSIA = `${ISO_639_1_RUSSIAN}-${ISO_3166_RUSSIA}`;
export const LOCALE_SLOVAK_SLOVAKIA = `${ISO_639_1_SLOVAK}-${ISO_3166_SLOVAKIA}`;
export const LOCALE_SLOVENIAN_SLOVENIA = `${ISO_639_1_SLOVENIAN}-${ISO_3166_SLOVENIA}`;
export const LOCALE_SERBIAN_SERBIA = `${ISO_639_1_SERBIAN}-${ISO_3166_SERBIA}`;
export const LOCALE_SERBIAN_LATIN_SERBIA = `${ISO_639_1_SERBIAN}-Latn-${ISO_3166_SERBIA}`;
export const LOCALE_SWEDISH_SWEDEN = `${ISO_639_1_SWEDISH}-${ISO_3166_SWEDEN}`;
export const LOCALE_THAI_THAILAND = `${ISO_639_1_THAI}-${ISO_3166_THAILAND}`;
export const LOCALE_VIETNAMESE_VIETNAM = `${ISO_639_1_VIETNAMESE}-${ISO_3166_VIETNAM}`;
export const LOCALE_TURKISH_TURKEY = `${ISO_639_1_TURKISH}-${ISO_3166_TURKEY}`;
export const LOCALE_UKRAINIAN_UKRAINE = `${ISO_639_1_UKRAINIAN}-${ISO_3166_UKRAINE}`;
export const LOCALE_CHINESE_CHINA = `${ISO_639_1_CHINESE}-${ISO_3166_CHINA}`;
export const LOCALE_CHINESE_TAIWAN = `${ISO_639_1_CHINESE}-${ISO_3166_TAIWAN}`;
export const LOCALE_JAPANESE_JAPAN = `${ISO_639_1_JAPANESE}-${ISO_3166_JAPAN}`;
export const LOCALE_KOREAN_KOREA = `${ISO_639_1_KOREAN}-${ISO_3166_KOREA}`;
export const DEFAULT_LOCALE_CODE = LOCALE_ENGLISH_USA;
export const LOCALES = [
    {
        code: LOCALE_BULGARIAN_BULGARIA,
        name: 'Bulgarian',
        nativeLanguageName: 'български',
        fallbackCode: LOCALE_ENGLISH_USA,
        localeLanguage: 'BG',
        countryName: 'Bulgaria',
    },
    {
        code: LOCALE_CZECH_CZECH_REPUBLIC,
        name: 'Czech',
        nativeLanguageName: 'Čeština',
        fallbackCode: LOCALE_ENGLISH_USA,
        localeLanguage: 'CS',
        countryName: 'Czech Republic',
    },
    {
        code: LOCALE_DANISH_DENMARK,
        name: 'Danish',
        nativeLanguageName: 'Dansk',
        fallbackCode: LOCALE_ENGLISH_USA,
        localeLanguage: 'DA',
        countryName: 'Denmark',
    },
    {
        code: LOCALE_GERMAN_GERMANY,
        name: 'German (Germany)',
        nativeLanguageName: 'Deutsch',
        fallbackCode: LOCALE_ENGLISH_USA,
        localeLanguage: 'DE',
        countryName: 'Deutschland',
    },
    {
        code: LOCALE_GERMAN_SWITZERLAND,
        name: 'German (Switzerland)',
        nativeLanguageName: 'Deutsch (Schweiz)',
        fallbackCode: LOCALE_ENGLISH_USA,
        localeLanguage: 'DE',
        countryName: 'Schweiz',
    },
    {
        code: LOCALE_ESTONIAN_ESTONIA,
        name: 'Estonian',
        nativeLanguageName: 'Eesti',
        fallbackCode: LOCALE_ENGLISH_USA,
        localeLanguage: 'ET',
        countryName: 'Estonia',
    },
    {
        code: LOCALE_ENGLISH_UK,
        name: 'English (UK)',
        nativeLanguageName: 'English (UK)',
        fallbackCode: LOCALE_ENGLISH_USA,
        localeLanguage: 'EN',
        countryName: 'UK, Australia, Ireland, India, UAE, South Africa, Singapore, Saudi Arabia, Qatar, Philippines, Oman, Malaysia, Kuwait, Israel, Indonesia, Bangladesh, Thailand',
    },
    {
        code: LOCALE_ENGLISH_USA,
        name: 'U.S. English',
        nativeLanguageName: 'English (US)',
        fallbackCode: null,
        localeLanguage: 'EN',
        countryName: 'United States',
    },
    {
        code: LOCALE_SPANISH_SPAIN,
        name: 'Spanish (Spain)',
        nativeLanguageName: 'Español (España)',
        fallbackCode: LOCALE_ENGLISH_USA,
        localeLanguage: 'ES',
        countryName: 'España',
    },
    {
        code: LOCALE_SPANISH_MEXICO,
        name: 'Spanish (Mexico)',
        nativeLanguageName: 'Español (México)',
        fallbackCode: LOCALE_ENGLISH_USA,
        localeLanguage: 'ES',
        countryName: 'Mexíco, Argentina, Bolivia, Chile, Colombia, Ecuador, Peru, Uruguay',
    },
    {
        code: LOCALE_FINISH_FINLAND,
        name: 'Finnish',
        nativeLanguageName: 'Suomi',
        fallbackCode: LOCALE_ENGLISH_USA,
        localeLanguage: 'FI',
        countryName: 'Finland',
    },
    {
        code: LOCALE_FRENCH_CANADA,
        name: 'French (Canada)',
        nativeLanguageName: 'Français (Canada)',
        fallbackCode: LOCALE_ENGLISH_USA,
        localeLanguage: 'FR',
        countryName: 'Canada',
    },
    {
        code: LOCALE_FRENCH_FRANCE,
        name: 'French (France)',
        nativeLanguageName: 'Français',
        fallbackCode: LOCALE_ENGLISH_USA,
        localeLanguage: 'FR',
        countryName: 'France',
    },
    {
        code: LOCALE_GREEK_GREECE,
        name: 'Greek',
        nativeLanguageName: 'Ελληνικά',
        fallbackCode: LOCALE_ENGLISH_USA,
        localeLanguage: 'EL',
        countryName: 'Greece',
    },
    {
        code: LOCALE_CROATIAN_CROATIA,
        name: 'Croatian',
        nativeLanguageName: 'Hrvatski',
        fallbackCode: LOCALE_ENGLISH_USA,
        localeLanguage: 'HR',
        countryName: 'Croatia',
    },
    {
        code: LOCALE_ITALIAN_ITALY,
        name: 'Italian (Italy)',
        nativeLanguageName: 'Italiano',
        fallbackCode: LOCALE_ENGLISH_USA,
        localeLanguage: 'IT',
        countryName: 'Italia',
    },
    {
        code: LOCALE_LATVIAN_LATVIA,
        name: 'Latvian',
        nativeLanguageName: 'Latviešu',
        fallbackCode: LOCALE_ENGLISH_USA,
        localeLanguage: 'LV',
        countryName: 'Latvia',
    },
    {
        code: LOCALE_LITHUANIAN_LITHUANIA,
        name: 'Lithuanian',
        nativeLanguageName: 'Lietuvių',
        fallbackCode: LOCALE_ENGLISH_USA,
        localeLanguage: 'LT',
        countryName: 'Lithuania',
    },
    {
        code: LOCALE_HUNGARIAN_HUNGARY,
        name: 'Hungarian',
        nativeLanguageName: 'Magyar',
        fallbackCode: LOCALE_ENGLISH_USA,
        localeLanguage: 'HU',
        countryName: 'Hungary',
    },
    {
        code: LOCALE_DUTCH_NETHERLAND,
        name: 'Dutch',
        nativeLanguageName: 'Nederlands',
        fallbackCode: LOCALE_ENGLISH_USA,
        localeLanguage: 'NL',
        countryName: 'Netherland, Belgium',
    },
    {
        code: LOCALE_NORSE_NORWAY,
        name: 'Norse / Norwegian',
        nativeLanguageName: 'Norsk',
        fallbackCode: LOCALE_ENGLISH_USA,
        localeLanguage: 'NO',
        countryName: 'Norway',
    },
    {
        code: LOCALE_POLISH_POLAND,
        name: 'Polish (Poland)',
        nativeLanguageName: 'Polski',
        fallbackCode: LOCALE_ENGLISH_USA,
        localeLanguage: 'PL',
        countryName: 'Polska',
    },
    {
        code: LOCALE_PORTUGUESE_BRAZIL,
        name: 'Portuguese (Brazil)',
        nativeLanguageName: 'Português (Brasil)',
        fallbackCode: LOCALE_ENGLISH_USA,
        localeLanguage: 'PT',
        countryName: 'Brasil',
    },
    {
        code: LOCALE_PORTUGUESE_PORTUGAL,
        name: 'Portuguese (Portugal)',
        nativeLanguageName: 'Português (Portugal)',
        fallbackCode: LOCALE_ENGLISH_USA,
        localeLanguage: 'PT',
        countryName: 'Portugal',
    },
    {
        code: LOCALE_ROMANIAN_ROMANIA,
        name: 'Romanian',
        nativeLanguageName: 'Română',
        fallbackCode: LOCALE_ENGLISH_USA,
        localeLanguage: 'RO',
        countryName: 'Romania',
    },
    {
        code: LOCALE_RUSSIAN_RUSSIA,
        name: 'Russian (Russia)',
        nativeLanguageName: 'Русский',
        fallbackCode: LOCALE_ENGLISH_USA,
        localeLanguage: 'RU',
        countryName: 'Россия',
    },
    {
        code: LOCALE_SLOVAK_SLOVAKIA,
        name: 'Slovak',
        nativeLanguageName: 'Slovenčina',
        fallbackCode: LOCALE_ENGLISH_USA,
        localeLanguage: 'SK',
        countryName: 'Slovakia',
    },
    {
        code: LOCALE_SLOVENIAN_SLOVENIA,
        name: 'Slovenian',
        nativeLanguageName: 'Slovenščina',
        fallbackCode: LOCALE_ENGLISH_USA,
        localeLanguage: 'SL',
        countryName: 'Slovenia',
    },
    {
        code: LOCALE_SERBIAN_LATIN_SERBIA,
        name: 'Serbian (Latin, Serbia)',
        nativeLanguageName: 'Srpski',
        fallbackCode: LOCALE_ENGLISH_USA,
        localeLanguage: 'SR',
        countryName: 'Serbia',
    },
    {
        code: LOCALE_SWEDISH_SWEDEN,
        name: 'Swedish',
        nativeLanguageName: 'Svenska',
        fallbackCode: LOCALE_ENGLISH_USA,
        localeLanguage: 'SV',
        countryName: 'Sweden',
    },
    {
        code: LOCALE_THAI_THAILAND,
        name: 'Thai',
        nativeLanguageName: 'ไทย',
        fallbackCode: LOCALE_ENGLISH_USA,
        localeLanguage: 'TH',
        countryName: 'Thailand',
    },
    {
        code: LOCALE_VIETNAMESE_VIETNAM,
        name: 'Vietnamese',
        nativeLanguageName: 'Tiếng Việt',
        fallbackCode: LOCALE_ENGLISH_USA,
        localeLanguage: 'VI',
        countryName: 'Vietnam',
    },
    {
        code: LOCALE_TURKISH_TURKEY,
        name: 'Turkish',
        nativeLanguageName: 'Türkçe',
        fallbackCode: LOCALE_ENGLISH_USA,
        localeLanguage: 'TR',
        countryName: 'Turkey',
    },
    {
        code: LOCALE_UKRAINIAN_UKRAINE,
        name: 'Ukrainian',
        nativeLanguageName: 'Українська',
        fallbackCode: LOCALE_ENGLISH_USA,
        localeLanguage: 'UK',
        countryName: 'Ukraine',
    },
    {
        code: LOCALE_CHINESE_CHINA,
        name: 'Chinese (Simplified)',
        nativeLanguageName: '中文（简体）',
        fallbackCode: LOCALE_ENGLISH_USA,
        localeLanguage: 'ZH',
        countryName: 'China',
    },
    {
        code: LOCALE_CHINESE_TAIWAN,
        name: 'Chinese (Traditional)',
        nativeLanguageName: '中文（繁體）',
        fallbackCode: LOCALE_ENGLISH_USA,
        localeLanguage: 'ZH',
        countryName: 'Taiwan',
    },
    {
        code: LOCALE_JAPANESE_JAPAN,
        name: 'Japanese (Kanji)',
        nativeLanguageName: '日本語',
        fallbackCode: LOCALE_ENGLISH_USA,
        localeLanguage: 'JA',
        countryName: 'Japan',
    },
    {
        code: LOCALE_KOREAN_KOREA,
        name: 'Korean',
        nativeLanguageName: '한국어',
        fallbackCode: LOCALE_ENGLISH_USA,
        localeLanguage: 'KO',
        countryName: 'South Korea',
    },
];
